/** Figma live-tracker gold (decorative yellow / Yellow 400 + deep bronze). */
export const LIVE_GOLD = '#F7D002';
export const LIVE_GOLD_DEEP = '#443E1D';
export const LIVE_TRACK_BG = '#313131';

export const LIVE_GOLD_BORDER_GRADIENT =
  'linear-gradient(135deg, #F7D002 0%, #F7D002 32%, #443E1D 100%)';

export const LIVE_PROGRESS_STRIPE =
  'repeating-linear-gradient(-45deg, #F7D002 0 4px, #443E1D 4px 7px)';
